const translations = {
    components: 'Components',
    health: 'Health',
    serviceLog: 'Service Log'
};

export default translations;
